import styled from 'styled-components';
import {Drawer} from 'antd';
import {typographyStyles} from '../../../../utils/styles';

const StyledAddExpenseModal = styled(Drawer)`
  .ant-drawer-header-title {
    flex-direction: row-reverse;
    button {
      margin-inline-end: 0;
      margin-inline-start: 12px;
    }
  }

  .ant-drawer-footer {
    display: flex;
    justify-content: flex-end;
    padding: 16px 24px;

    button {
      &:not(:last-child) {
        margin-right: 8px;
      }
    }
  }

  .ant-picker {
    width: 100%;
  }
`;

const StyledAddExpenseModalTitle = styled.div`
  ${typographyStyles.heading.h5};
  margin-bottom: 24px;
`;


export {
  StyledAddExpenseModal,
  StyledAddExpenseModalTitle
};
